/*
 * @Author: Jin Biao
 * @Date: 2019-03-25 11:08:44
 * @Title: 此apis为请求外部接口所用
 * @Description: 请求其它后端接口所用
 */

/* eslint-disable */
// 普通请求
import axios from 'axios'
import config from './config'
import { Loading, Message } from 'element-ui'

// 超时时间
axios.defaults.timeout = 100000

// http请求拦截器 打开Loading
axios.interceptors.request.use(config => {
  // element ui Loading方法
  this.loadingInstance = Loading.service();
  return config
}, error => {
  this.loadingInstance.close();
  Message.error({
    message: '加载超时~'
  })

  return Promise.reject(error)
})

// http响应拦截器 关闭Loading
axios.interceptors.response.use(data => {// 响应成功关闭loading
  this.loadingInstance.close();
  return data
}, error => {
  this.loadingInstance.close();
  return Promise.reject(error)
})

// 添加请求拦截器  更新最新用户 KEY
axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么    // 获取KEY
  config.headers.uid = localStorage.getItem("pbw_user_pc_uid")
  config.headers.token = localStorage.getItem("pbw_user_pc_token")
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加请求拦截器  判断是否需要登录权限 以及是否登录
axios.interceptors.response.use(function (response) {
  if (response.data.code == 777777) {
    localStorage.removeItem("pbw_user_pc_uid")
    localStorage.removeItem("pbw_user_pc_token")
    setTimeout(function () {
      window.location.href = '/login?type=lose'
    }, 500)
  }
  // 正常请求即可每10分钟进行检测【正常使用则一直加一小时】
  return response;
});


// axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
/*普通接口模块*/
axios.defaults.baseURL = 'https://baidsdas.com';

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';


// 用户注册-手机验证码
export const smsCode = params => { return axios.post('/user/reg/smsCode', params, config).then(res => res.data) }
// 用户完善资料
export const updateUserDetail = params => { return axios.post('/user/reg/updateUserDetail', params, config).then(res => res.data) }
// 用户登录-验证码
export const api_smscode = params => { return axios.post('/user/login/smscode', params, config).then(res => res.data) }
// 用户登录- 密码
export const api_pwd = params => { return axios.post('/user/login/pwd', params, config).then(res => res.data) }
// 用户密码-校验手机验证码
export const checkTelCode = params => { return axios.post('/user/pwd/checkTelCode', params, config).then(res => res.data) }
// 用户密码-修改密码
export const tel = params => { return axios.post('/user/pwd/update/tel', params, config).then(res => res.data) }
export const email = params => { return axios.post('/user/pwd/update/email', params, config).then(res => res.data) }
// 短信服务-发送验证码
export const sendSmsToTel = params => { return axios.post('/sms/sendSmsToTel', params, config).then(res => res.data) }
// 邮箱服务-发送邮件
export const send = params => { return axios.post('/email/send', params, config).then(res => res.data) }
// 邮箱服务-校验邮箱验证码
export const api_emailcode = params => { return axios.post('/email/check/code', params, config).then(res => res.data) }
// 用户首页数据
export const indexUserData = params => { return axios.post('/user/oneself/indexUserData', params, config).then(res => res.data) }
// 用户个人详情数据
export const getUserDetail = params => { return axios.post('/user/oneself/getUserDetail', params, config).then(res => res.data) }
// 更新用户个人详情数据
export const updateUserDetailForIndex = params => { return axios.post('/user/oneself/updateUserDetailForIndex', params).then(res => res.data) }
// 获取城市级联数据
export const getCityData = params => { return axios.get('/common/getCityData', params, config).then(res => res.data) }
// 获取服务数据
export const getServeData = params => { return axios.get('/common/getServeData', params, config).then(res => res.data) }
// 增加用户认证信息
export const insertUserProof = params => { return axios.post('/user/oneself/insertUserProof', params, { headers: { 'Content-Type': 'application/json' } }).then(res => res.data) }
// 查询用户账户资金余额
export const selectUserAccoun = params => { return axios.post('/user/oneself/selectUserAccoun', params, config).then(res => res.data) }
// 发布个人服务
export const insertServes = params => { return axios.post('/user/oneself/server/insertServes', params, config).then(res => res.data) }
// 获取用户发布服务列表
export const selectUserServes = params => { return axios.post('/user/oneself/server/selectUserServes', params, config).then(res => res.data) }
// 获取服务列表详情
export const selectUserServesByCode = params => { return axios.post('/user/oneself/server/selectUserServesByCode', params, config).then(res => res.data) }
// 下架已发布服务
export const deleteUserServesByCode = params => { return axios.post('/user/oneself/server/deleteUserServesByCode', params, config).then(res => res.data) }
// 获取用户相册列表
export const selectUserPhotoBook = params => { return axios.post('/user/oneself/photo/selectUserPhotoBook', params, config).then(res => res.data) }
// 新增用户相册
export const insertUserPhotoBook = params => { return axios.post('/user/oneself/photo/insertUserPhotoBook', params, config).then(res => res.data) }
// 获取用户相册详情
export const selectUserPhotoBookByCode = params => { return axios.post('/user/oneself/photo/selectUserPhotoBookByCode', params, config).then(res => res.data) }
// 新增用户相册图片
export const insertUserPhotoBookMapping = params => { return axios.post('/user/oneself/photo/insertUserPhotoBookMapping', params, config).then(res => res.data) }
// 修改相册信息
export const updateUserPhotoBook = params => { return axios.post('/user/oneself/photo/updateUserPhotoBook', params, config).then(res => res.data) }
// 删除用户相册
export const deleteUserPhotoBook = params => { return axios.post('/user/oneself/photo/deleteUserPhotoBook', params, config).then(res => res.data) }
// 删除相册下某张（组）照片
export const deletePhotoBookMapping = params => { return axios.post('/user/oneself/photo/deletePhotoBookMapping', params, config).then(res => res.data) }
// 获取用户账户安全详情
export const selectUserDetailByProof = params => { return axios.post('/user/oneself/info/selectUserDetailByProof', params, config).then(res => res.data) }
// 根据用户旧密码修改新密码
export const updateUserPasswrod = params => { return axios.post('/user/oneself/info/updateUserPasswrod', params, config).then(res => res.data) }
// 查询认证信息审核状态
export const selectUserProof = params => { return axios.post('/user/oneself/selectUserProof', params, config).then(res => res.data) }


// 检索城市数据信息
export const selectRegionByName = params => { return axios.post('/user/explore/region/selectRegionByName', params, config).then(res => res.data) }
// 按条件索引服务数据
export const selectServes = params => { return axios.post('/user/explore/selectServes', params).then(res => res.data) }
// 查看用户代言旅行列表
export const selectTravelList = params => { return axios.post('/user/explore/travel/selectTravelList', params).then(res => res.data) }
// 获取用户发布动态列表
export const selectUserDynamicList = params => { return axios.post('/user/dynamic/selectUserDynamicList', params).then(res => res.data) }
// 获取用户动态详情
export const selectUserDynamicDetail = params => { return axios.post('/user/dynamic/selectUserDynamicDetail', params, config).then(res => res.data) }
// 用户评论动态
export const insertUserReply = params => { return axios.post('/user/dynamic/insertUserReply', params, config).then(res => res.data) }
// 发布动态
export const insertUserDynamic = params => { return axios.post('/user/dynamic/insertUserDynamic', params).then(res => res.data) }
// 查看代言旅行详情
export const selectTravelDetail = params => { return axios.post('/user/explore/travel/selectTravelDetail', params, config).then(res => res.data) }
// 获取用户照片墙
export const getUserPhotoWall = params => { return axios.post('/user/oneself/getUserPhotoWall', params, config).then(res => res.data) }
// 用户发布订单
export const insertServeOrder = params => { return axios.post('/user/server/order/insertServeOrder', params).then(res => res.data) }
export const selectServeOrder = params => { return axios.post('/user/server/order/selectServeOrder', params, config).then(res => res.data) }
// 创建订单二维码
export const codeURL = params => { return axios.post('/pay/native/create/codeURL', params, config).then(res => res.data) }
export const refund = params => { return axios.post('/pay/refund', params, config).then(res => res.data) }
export const queryOrderStatus = params => { return axios.post('/user/server/order/queryOrderStatus', params, config).then(res => res.data) }
export const canelOrderByUser = params => { return axios.post('/user/server/order/canelOrderByUser', params, config).then(res => res.data) }



// 买家订单列表
export const selectServeOrderList = params => { return axios.post('/user/server/order/selectServeOrderList', params).then(res => res.data) }
// 卖家订单列表
export const selectServeOrderListByPush = params => { return axios.post('/user/server/order/selectServeOrderListByPush', params).then(res => res.data) }
// 用户确认订单
export const confirmOrderByUser = params => { return axios.post('/user/server/order/confirmOrderByUser', params, config).then(res => res.data) }
// 用户发布代言旅行
export const insertTravel = params => { return axios.post('/user/explore/travel/insertTravel', params, { headers: { 'Content-Type': 'application/json' } }).then(res => res.data) }
// 查询服务评价信息
export const queryEvelInfo = params => { return axios.post('/user/server/order/queryEvelInfo', params).then(res => res.data) }
// 查询服务协议详情
export const serverProCont = params => { return axios.get('/common/show/detail/serverProCont', params, config).then(res => res.data) }
// 查询轮播图列表
export const moveTu = params => { return axios.get('/common/show/moveTu', params, config).then(res => res.data) }



// WEBPACK FOOTER //
// ./src/api/apis.js